import * as React from 'react';
import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppContext } from '../../../context';
import AccreditationProvider from './context';
import AccreditationBodiesList from './List';
import AccreditationVersions from './Versions';

const Accreditation: React.FC = () => {
  const { enforcePermissions } = useContext(AppContext);

  return (
    <AccreditationProvider>
      <Routes>
        <Route
          path=''
          element={<AccreditationBodiesList />}
        />
        <Route
          path=':id/versions/*'
          element={<AccreditationVersions />}
        />
      </Routes>
    </AccreditationProvider>
  );
};

export default Accreditation;
